@use '@css/variables';

.columns {
  margin-top: 2em;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 1.25em;

  & > * {
    border: 1px solid var(--beigedarker);
    background-color: #ffffffed;
    border-radius: var(--border-radius);
    padding: 1.25em;
    flex: 1;

    h3 {
      margin-bottom: 1em;
    }

    ul {
      gap: .5em;
      text-align: left;
    }
  }

  // stacked cards (mobile) take the full width
  &.stretch {
    align-items: stretch;
  }

  &.noBorder > * {
    border: 0 none;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    gap: 1.25em;
  }
}

@media only screen and (min-width: variables.$sm-breakpoint) {
  .columns {
    flex-direction: row;
    justify-content: center;

    &.stretch {
      align-items: flex-start;
    }

    // cap each card at one third so fewer than 3 cards keep the 3-column width
    & > * {
      max-width: calc((100% - 2.5em) / 3);
    }
  }
}